export default "__VITE_ASSET__h1rD6c2q__"